export const Basics = Object.freeze
( {
	bad_configuration: '000000',
	fetch_layer: '000001',
	unauthorized: '000002',
	nack: '000003',
	invalid_status: '000004',
	invalid_data: '000005',
	no_payload: '000006'
} );


export const System = Object.freeze
( {
	// System related codes = 100 domain
	unexpected_error: '100001',			// Anything else
	endpoint_not_found: '100002',		// Error for endpoint not found
	internal_server_error: '100003',	// Error 500 and other code/server errors
	unauthorized: '100004',				// System-wide unauthorized access (login expired but renewable)
	forbidden: '100005',				// System-wide forbidden access (logged out)
	bad_request: '100006'				// System-wide bad request (incompatible JSON format or input data)
} );


export const User = Object.freeze
( {
	// User related codes = 200 domain
	login_incorrect: '200001',		// Login incorrect
	unauthorized: '200002',			// The API user is not authorized
	forbidden: '200003'			// The API user does not have enough permissions
} );


export const Data = Object.freeze
( {
	// Generic data related codes = 300 domain
	not_found: '300001',			// Requested data does not exists
	bad_data: '300002'				// Error for missing parameters or bad data types (but correct JSON format)
} );


//


export function Is_supported ( code )
{
	return Object.values( Basics ).includes( code )
		||
		Object.values( System ).includes( code )
		||
		Object.values( User ).includes( code )
		||
		Object.values( Data ).includes( code );
}
